module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_terms", [["div",{"class":"site-page terms"},[["section",{"class":"static-page-wrapper"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title"},[["p",{},[["textNode",{"text":"Website Terms-of-Use Agreement"}]]]]]]]]],["section",{"class":"static-page-content"},[["div",{"class":"page-width static-page-docs"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/terms.tpl
// module id = 1115
// module chunks = 4